import { render, staticRenderFns } from "./RecurrenceInterventionFrequenceEdit.vue?vue&type=template&id=10172d11"
import script from "./RecurrenceInterventionFrequenceEdit.vue?vue&type=script&lang=ts"
export * from "./RecurrenceInterventionFrequenceEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports